export default "__VITE_ASSET__BJOd7eIR__"